<div
  class="flex h-12 overflow-hidden rounded-md bg-black/10 p-2 text-xs shadow-[inset_0_1px_2px_rgba(0,0,0,0.2)] md:text-base"
>
  @let progressBarClasses =
    'flex items-center justify-center text-white h-full transition-[width] duration-1000 ease-in-out min-w-[max(20%,5.5rem)] md:min-w-[max(20%,7rem)] w-0';
  <div
    class="{{ progressBarClasses }} bg-[#0D62FF] rounded-tl-sm rounded-bl-sm"
    [ngStyle]="{ width: inServicePercentage() + '%' }"
  >
    <span class="mr-1 text-base font-semibold md:text-xl">{{
      inService()
    }}</span>
    In Service
  </div>
  <div
    class="{{ progressBarClasses }} rounded-tr-sm rounded-br-sm bg-black/40"
    [ngStyle]="{ width: pendingPercentage() + '%' }"
  >
    <span class="mr-1 text-base font-semibold md:text-xl">{{ pending() }}</span>
    Pending
  </div>
</div>
